import { render } from "./LinkButton.vue?vue&type=template&id=b8fa157e&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"

import "./LinkButton.vue?vue&type=style&index=0&id=b8fa157e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8fa157e"]])

export default __exports__